import AttendanceType from "./actionTypes"

const INIT_STATE = {
  workClass: {
    loading: true,
    data: []
  },
  today: {
    loading: false,
    data: {}
  },
  otherWork: {
    loading: false,
    data: []
  },
  history: {
    loading: true,
    data: []
  },
  historyByDate: {
    loading: true,
    data: []
  },
  assignmentList: {
    loading: true,
    data: []
  },
  clockIn: {
    loading: false
  },
  clockOut: {
    loading: false
  },
  putAttendance: {
    loading: false
  },
  allHistory: {
    loading: true,
    data: []
  },
  detailDateHistory: {
    loading: true,
    data: {}
  },
  order: {
    loading: true,
    data: []
  },
  deleteData: {
    loading: false,
    data: []
  },

}

const Attendance = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AttendanceType.GET_ATTENDANCE_WORK_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        workClass: action.payload,
      }
    case AttendanceType.GET_ATTENDANCE_OTHER_WORK_LIST_SUCCESS:
      return {
        ...state,
        otherWork: action.payload,
      }
    case AttendanceType.GET_ATTENDANCE_ALL_ORDER_LIST_SUCCESS:
      return {
        ...state,
        order: action.payload,
      }

    case AttendanceType.GET_ATTENDANCE_WORK_TODAY_SUCCESS:
      return {
        ...state,
        today: action.payload,
      }

    case AttendanceType.GET_ATTENDANCE_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload,
      }

    case AttendanceType.GET_ATTENDANCE_HISTORY_BY_DATE_SUCCESS:
      return {
        ...state,
        allHistory: action.payload,
      }
    case AttendanceType.GET_ATTENDANCE_DETAIL_HISTORY_DATE_SUCCESS:
      return {
        ...state,
        detailDateHistory: action.payload,
      }

    case AttendanceType.GET_ATTENDANCE_ASSIGMENT_LIST_SUCCESS:
      return {
        ...state,
        assignmentList: action.payload,
      }
    case AttendanceType.POST_CLOCK_IN_SUCCESS:
      return {
        ...state,
        clockIn: action.payload,
      }
    case AttendanceType.POST_CLOCK_OUT_SUCCESS:
      return {
        ...state,
        clockOut: action.payload,
      }

    case AttendanceType.PUT_ATTENDANCE_DATE_SUCCESS:
      return {
        ...state,
        putAttendance: action.payload,
      }

    case AttendanceType.DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        deleteData: action.payload,
      }

    default:
      return state
  }
}

export default Attendance
